import React from 'react';

type Props = {
    className?: string;
    fillColor?: string;
    width?: number;
    height?: number;
};

const SmartEditIcon = React.memo(function SmartEditIcon({
    className,
    fillColor = 'currentColor',
    width = 20,
    height = 20,
}: Props) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.83223 16.2618H4.60758L13.7425 7.10325L12.9672 6.3279L3.83223 15.4864V16.2618ZM16.5768 6.21919L13.863 3.50542L14.4907 2.86594C14.8132 2.54347 15.201 2.38027 15.6542 2.37635C16.1074 2.37242 16.4953 2.52776 16.8178 2.84238L17.4282 3.45288C17.7115 3.72824 17.8433 4.05523 17.8236 4.43385C17.804 4.81248 17.6643 5.13163 17.4047 5.39129L16.5768 6.21919ZM15.7136 7.08242L5.15469 17.6413H2.44092V14.9275L12.988 4.38042L15.7136 7.08242ZM13.3666 6.71556L12.9672 6.3279L13.7425 7.10325L13.3666 6.71556Z"
                fill={fillColor}
            />
            <path
                d="M8.54657 6.88376L7.92502 5.41627L6.39941 4.73239L7.92502 4.06276L8.54657 2.6665L9.18224 4.06276L10.7079 4.73239L9.18224 5.41627L8.54657 6.88376Z"
                fill={fillColor}
            />
            <path
                d="M12.1566 3.27736L11.7176 2.2528L10.6401 1.77534L11.7176 1.30783L12.1566 0.333008L12.6056 1.30783L13.6831 1.77534L12.6056 2.2528L12.1566 3.27736Z"
                fill={fillColor}
            />
            <path
                d="M15.8236 11.4444L15.3846 10.4198L14.3071 9.94233L15.3846 9.47482L15.8236 8.5L16.2725 9.47482L17.35 9.94233L16.2725 10.4198L15.8236 11.4444Z"
                fill={fillColor}
            />
        </svg>
    );
});

export default SmartEditIcon;
